export default __webpack_public_path__ + "static/media/CNo.34-0.b2ee9f55.jpg";